/**
 * Where clicking a notification should take the user.
 * Ticket and To Do notifications jump straight to the item; everything else
 * opens the generic notification detail page.
 */
export const notificationTarget = (n) => {
  if (!n) return "/user/notifications";
  if (n.requestType === "Task") {
    // The To Do page opens the task named in ?task= and moves to wherever it lives.
    const base = n.link || "/user/todo/tasks";
    return n.requestId ? `${base}?task=${encodeURIComponent(n.requestId)}` : base;
  }
  if (n.requestType === "Ticket") {
    return (
      n.link ||
      (n.requestId
        ? `/ticketing/tickets/${n.requestId}`
        : `/user/notifications/${n.id}`)
    );
  }
  return `/user/notifications/${n.id}`;
};
